<template>
  <el-dialog
    title="合同费用详情"
    :visible.sync="visible"
    width="80%"
    :before-close="handleClose"
  >
    <!-- 合同基础信息 -->
    <el-card class="info-card">
      <div slot="header" class="card-header">
        <span>合同基础信息</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="info-item">
            <span class="label">合同编号：</span>
            <span class="value">{{ contractInfo.contractId }}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="info-item">
            <span class="label">合同来源：</span>
            <span class="value"
              >房屋租赁协议模板（装修抵租金.不含采暖费版本）</span
            >
          </div>
        </el-col>
        <el-col :span="8">
          <div class="info-item">
            <span class="label">总金额：</span>
            <span class="value">{{ totalAmount }} 元</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="info-item">
            <span class="label">乙方名称：</span>
            <span class="value">{{ contractInfo.partyBName || "测试12" }}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="info-item">
            <span class="label">乙方电话：</span>
            <span class="value">{{
              contractInfo.partyBPhone || "18243346101"
            }}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="info-item">
            <span class="label">负责人：</span>
            <span class="value">徐强</span>
          </div>
        </el-col>
        <el-col :span="8" v-if="contractInfo.signDate">
          <div class="info-item">
            <span class="label">签订日期：</span>
            <span class="value">{{ contractInfo.signDate }}</span>
          </div>
        </el-col>
      </el-row>
    </el-card>

    <!-- 合同付款详情 -->
    <el-card class="table-card" style="margin-top: 20px">
      <div slot="header" class="card-header">
        <span>合同付款详情</span>
      </div>
      <el-table :data="paymentList" border style="width: 100%">
        <el-table-column prop="paymentNo" label="付款序号" align="center" />
        <el-table-column prop="paymentDate" label="付款日期" align="center" />
        <el-table-column prop="startDate" label="租赁起始日期" align="center" />
        <el-table-column prop="endDate" label="租赁截止日期" align="center" />
        <el-table-column prop="rentalDays" label="计租天数" align="center" />
        <el-table-column prop="rentAmount" label="租金金额(元)" align="center">
          <template slot-scope="scope">
            {{ scope.row.rentAmount.toFixed(2) }}
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { queryContractDetail } from "@/api/contract/newContractManageApi";

export default {
  name: "ContractNewDetail",
  props: {
    contractId: {
      type: String,
      required: true,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      contractInfo: {},
      paymentList: [],
    };
  },
  watch: {
    visible(val) {
      if (val && this.contractId) {
        this.getDetail();
      }
    },
  },
  computed: {
    totalAmount() {
      return this.paymentList
        .reduce((sum, item) => sum + item.rentAmount, 0)
        .toFixed(2);
    },
  },
  methods: {
    async getDetail() {
      try {
        const res = await queryContractDetail({ contractId: this.contractId });
        this.paymentList = res.data || [];
        // 这里可以额外获取合同基础信息，暂时用示例数据填充
        this.contractInfo = { contractId: this.contractId };
      } catch (error) {
        this.$message.error("获取费用详情失败");
      }
    },
    handleClose() {
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.info-card,
.table-card {
  :deep(.el-card__header) {
    text-align: center;
    .card-header {
      font-size: 18px;
      font-weight: 500;
    }
  }
}
.info-item {
  margin: 10px 0;
  .label {
    color: #606266;
    font-size: 16px;
  }
  .value {
    color: #303133;
    font-size: 16px;
    margin-left: 8px;
  }
}
.dialog-footer {
  text-align: right;
}
</style>
